import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import App from './components/App';

import { Provider } from 'react-redux';
import { store } from 'redux/store';
import './fonts/Montserrat/Montserrat-VariableFont_wght.ttf';

const tagManagerArgs = {
  gtmId: import.meta.env.REACT_APP_GTM_ACCOUNT,
};

TagManager.initialize(tagManagerArgs);

// Initialize dataLayer for GTM
window.dataLayer = window.dataLayer || [];

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
